import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
// import Backend from 'i18next-http-backend';
// import { getBaseUrl } from '@utils/constants';
import { t as i18t } from 'i18next';
import en from './lang/en.json';
import cn from './lang/cn.json';
import hk from './lang/hk.json';

export enum Languages {
  EN = 'en',
  CN = 'cn',
  HK = 'hk'
}

export const getLanguage = (): Languages => {
  return (localStorage.getItem('lang') || Languages.CN) as Languages;
};
export const setLanguage = (lang: Languages) => {
  localStorage.setItem('lang', lang);
};

export const t = (str: string, opts?: any) => {
  return i18t(str, opts) as string;
};

/**
 * 批量更新翻译内容（从接口获取的数据）
 * @param translations 翻译对象，key 为翻译键（支持点分隔的嵌套路径），value 为翻译值
 * @param lng 语言代码，默认为当前语言
 * @param deep 是否深度合并，默认为 true
 * @param overwrite 是否覆盖现有值，默认为 true
 * @example
 * // 批量更新多个翻译
 * updateTranslations({
 *   'common.scoreRate': '你好',
 *   'common.check': '检查',
 *   'userCenter.title': '个人中心'
 * })
 *
 * // 从接口获取数据后更新
 * const response = await api.getTranslations();
 * updateTranslations(response.data)
 */
export const updateTranslations = (
  translations: Record<string, string>,
  lng?: Languages,
  deep: boolean = true,
  overwrite: boolean = true
) => {
  const language = lng || (getLanguage() as Languages);
  const namespace = 'translation';

  // 将点分隔的键转换为嵌套对象结构
  const resourceBundle: any = {};

  Object.entries(translations).forEach(([key, value]) => {
    const keys = key.split('.');
    let current = resourceBundle;

    // 构建嵌套对象结构
    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) {
        current[keys[i]] = {};
      }
      current = current[keys[i]];
    }

    // 设置最终值
    current[keys[keys.length - 1]] = value;
  });

  // 使用 addResourceBundle 批量更新翻译
  // deep: true 表示深度合并，overwrite: true 表示覆盖现有值
  i18next.addResourceBundle(language, namespace, resourceBundle, deep, overwrite);

  // 如果当前语言与更新的语言一致，触发 changeLanguage 来确保更新生效
  if (i18next.language === language) {
    i18next.changeLanguage(language);
  }
};

i18next
  .use(initReactI18next)
  // .use(Backend)
  .init({
    supportedLngs: [Languages.EN, Languages.CN, Languages.HK],
    interpolation: {
      escapeValue: false, // 全局关闭转义:cite[2]
      format: function (value, format, lng) {
        // 如果值是undefined或null，返回空字符串
        if (value === undefined || value === null || value === '') {
          return '';
        }
        return value;
      }
    },
    resources: {
      en: {
        translation: en
      },
      cn: {
        translation: cn
      },
      hk: {
        translation: hk
      }
    },
    lng: getLanguage()
    // backend: {
    //   loadPath: async function (lngs: any, namespaces: any) {
    //     const lngKey = lngs?.[0] || Languages.CN;
    //     return `${getBaseUrl()}/public/locales/${lngKey}.json?timestamp=${new Date().getTime()}`;
    //   },
    //   /**
    //    * 用于对响应的结果进行结构转化
    //    * @param data 原始响应的字符串结果
    //    */
    //   parse: function (data: string, lngs: any, namespaces: any) {
    //     const obj = eval('(' + data + ')');
    //     return obj;
    //   },
    //   /**
    //    * 是否允许跨域
    //    */
    //   crossDomain: true,
    //   /**
    //    * 是否允许携带登录凭证
    //    */
    //   withCredentials: true,
    // },
  });

export default i18next;
